<style scoped>
  .silder{background-color:#FFF;border-right:solid 1px #d7dde4;width:200px}
  .silder-item{padding:0 5px;text-align: left;height:60px;margin:0 20px;font-size:14px;border-bottom:solid 1px #d7dde4;cursor: pointer;}
  .silder-item:hover{background-color:#f5fcff;color:#00a2e9}
  .silder-item:hover .tips-icon{display:inline-block}
  .tips-icon{font-size:20px;display: none}
  .task-panel{padding:0px 20px;border-bottom:1px dashed #d7dde4;}
  .silder-title{cursor:pointer;height: 60px;color:#00a2e9;line-height:60px;margin:0 6px;padding:0 18px;font-size:14px;border-bottom:1px solid #d7dde4}
</style>
<template>
  <div>
    <Layout>
      <Sider hide-trigger class="silder" style="width:300px;flex:0 0 300px;max-width:300px;padding-bottom: 50px;">
        <div class="silder-title">
          <div @click="addStage()">
            <span style="background-color:#00a2e9">
              <Icon type="md-add" style="color: white"/>
            </span>
            添加阶段
          </div>
        </div>
        <div class="silder-item" v-if="model.stage.length>0" v-for="(item,index) in model.stage" :style="index==stageIndex?'background-color:#f5fcff;color:#00a2e9':''">
          <Input @on-blur="saveModel(item,index,'stage')" v-if="item.edit==true" v-model="item.name" placeholder="请输入阶段名称"></Input>
          <Row type="flex" justify="center" v-else>
            <Col span="20">
              <div style="line-height:60px" @click="stageIndex=index">
                <div style="display: inline-block;vertical-align:middle;line-height: 1em">{{item.name}}</div>
              </div>
            </Col>
            <Col span="4" style="line-height:60px">
              <span class="tips-icon">
                <Icon type="ios-create-outline" @click="item.edit=1"/>
                <Icon type="ios-trash-outline" @click="deleteStage(index)"/>
              </span>
            </Col>
          </Row>
        </div>
      </Sider>
      <Sider hide-trigger class="silder" style="width:300px;flex:0 0 300px;max-width:300px">
        <div class="silder-title" @click="addTask()">
          <span style="background-color:#00a2e9">
            <Icon type="md-add" style="color: white"/>
          </span>
          添加任务
        </div>
        <template v-if="model.stage.length>0">
          <div class="silder-item" v-for="(item,index) in model.stage[stageIndex].task" :style="index==taskIndex?'background-color:#f5fcff;color:#00a2e9':''">
            <Input @on-blur="saveModel(item,index,'task')" v-if="item.edit==true" v-model="item.name" placeholder="请输入任务名称"></Input>
            <Row type="flex" justify="center" v-else>
              <Col span="20">
                <div style="line-height:60px" @click="taskIndex=index">
                  <div style="display: inline-block;vertical-align:middle;line-height: 1em">{{item.name}}</div>
                </div>
              </Col>
              <Col span="4" style="line-height:60px">
                <span class="tips-icon">
                  <Icon type="ios-create-outline" @click="item.edit=1"/>
                  <Icon type="ios-trash-outline" @click="deleteTask(index)"/>
                </span>
              </Col>
            </Row>
          </div>
        </template>
      </Sider>
      <Layout>
        <Content style="background-color:#FFF;" v-if="model.stage.length>0&&model.stage[stageIndex].task.length>0">
          <div class="task-panel">
            <div style="padding:10px"></div>
            <span style="font-size:18px">{{model.stage[stageIndex].task[taskIndex].name}}</span>
            <div style="padding:10px"></div>
          </div>
          <div class="task-panel">
            <div style="padding:15px"></div>
            <editor
                @on-blur="model.stage[stageIndex].task[taskIndex].content.advice = $event;saveModel()"
                :content="model.stage[stageIndex].task[taskIndex].content.advice"
            ></editor>
            <div style="padding:15px"></div>
          </div>
          <!--<div class="task-panel">-->
            <!--<div style="font-size:14px;line-height:50px;">-->
              <!--<Icon style="font-size:20px" type="md-time"/> 建议任务用时-->
              <!--<Input style="width:50px;display:inline-block" @on-blur="saveModel" v-model="model.stage[stageIndex].task[taskIndex].content.date"></Input>天-->
              <!--<span style="color: #c3cbd6;font-size:12px;">（无限制可填写0）</span>-->
            <!--</div>-->
          <!--</div>-->
          <div class="task-panel">
            <div style="font-size:14px;line-height:50px;">
              <Icon style="font-size:20px" type="md-filing"/> 关联文件
            </div>
            <a
                target="_blank"
                v-for="(item,index) in model.stage[stageIndex].task[taskIndex].content.files"
               :href="getServerURL('default',false)+'/'+item.filesSrc"
                style="display: block;background-color:rgb(243,243,243);line-height:40px;padding:0 15px;font-size:14px;margin-bottom:5px;"
            >
              <Icon type="ios-cloud-download-outline" style="font-size:20px;margin-right:3px"/>
              <span style="vertical-align: middle">{{item.fileName}}</span>
              <Icon style="float:right;line-height:40px;font-size:20px;color:red" type="md-close-circle" @click="model.stage[stageIndex].task[taskIndex].content.files.splice(index,1);saveModel()"/>
            </a>
            <Upload
                multiple
                :show-upload-list="false"
                type="drag"
                :on-success="uploadSuccess"
                :on-remove="deleteFile"
                :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
                :data="{MenuId:menuId,UserId:userId}"
                :action="getServerURL('default',true)">
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或拖拽文件到此处完成上传</p>
              </div>
            </Upload>
            <div style="padding:15px"></div>
          </div>
          <!--<div class="task-panel">-->
            <!--<div style="font-size:14px;line-height:50px;">-->
              <!--<Icon style="font-size:20px" type="ios-person-add-outline" />关注人-->
              <!--<span style="float: right;font-size:24px;"><Icon type="md-add-circle" /></span>-->
            <!--</div>-->
            <!--<template>-->
              <!--<div style="background-color:rgb(243,243,243);line-height:40px;padding:0 15px;font-size:14px;margin-bottom:5px;">-->
                <!--<Avatar style="height:25px;width:25px;margin-right:5px;vertical-align: middle"/>-->
                <!--<span style="vertical-align: middle">郭帅</span>-->
                <!--<Icon style="float:right;line-height:40px;font-size:20px;color:red" type="md-close-circle" />-->
              <!--</div>-->
              <!--<div style="background-color:rgb(243,243,243);line-height:40px;padding:0 15px;font-size:14px;margin-bottom:5px;">-->
                <!--<Avatar style="height:25px;width:25px;margin-right:5px;vertical-align: middle"/>-->
                <!--<span style="vertical-align: middle">郭帅</span>-->
                <!--<Icon style="float:right;line-height:40px;font-size:20px;color:red" type="md-close-circle" />-->
              <!--</div>-->
              <!--<div style="padding:15px"></div>-->
            <!--</template>-->
          <!--</div>-->
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
  import Editor from "../../../components/system/editor";
  export default {
    name: "create",
    components: {Editor},
    data:function () {
      return{
        model:{
          stage:[],
        },
        stageIndex:0,
        taskIndex:0,
      }
    },
    watch:{
      'stageIndex':function () {
        this.taskIndex=0
      }
    },
    mounted:function(){
      this.getModel()
    },
    methods:{
      addStage:function(){
        this.model.stage.push({name:'',edit:true,task:[]})
      },
      addTask:function(){
        if(this.model.stage.length>0) {
          this.model.stage[this.stageIndex].task.push({
            name: '',
            edit: true,
            state: false,
            content:{
              advice:'',
              date:'',
              files:[],
              executor:[],
            }
          })
        }
      },
      deleteStage:function(index){
        var _this = this
        _this.$Modal.warning({
          title:'系统消息',
          content:'是否确认当前操作？',
          onOk:function () {
            _this.model.stage.splice(index,1)
            _this.stageIndex = 0
            _this.saveModel()
          },
        })
      },
      deleteTask:function(index){
        var _this = this
        _this.$Modal.confirm({
          title:'系统消息',
          content:'是否确认当前操作？',
          onOk:function () {
            _this.model.stage[_this.stageIndex].task.splice(index,1)
            _this.saveModel()
          },
        })
      },
      deleteFile:function(file,fileList){
        this.model.stage[this.stageIndex].task[this.taskIndex].content.files = []
        for(var i=0;i<fileList.length;i++){
          this.model.stage[this.stageIndex].task[this.taskIndex].content.files.push({
            fileName:fileList[i].response.Data.name,
            filesSrc:fileList[i].response.Data.path,
          })
        }
        this.saveModel()
      },
      uploadSuccess:function (response,file,fileList) {
        this.model.stage[this.stageIndex].task[this.taskIndex].content.files.push({
          fileName:response.Data.name,
          filesSrc:response.Data.path,
        })
        this.saveModel()
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功！'
        })
      },
      getModel:function(){
        var _this = this
        _this.send({
          headers:'A/ShowModeByDetail',
          data:{
            CaseActionDetailId:_this.$route.query.id
          },
          success:function (res) {
            if(res.CaseActionDetailContent){
              _this.$set(_this.model,'stage',res.CaseActionDetailContent)
            }
          }
        })
      },
      saveModel:function (item,index,type,ss) {
        if(item!=undefined){item.edit=0}
        if(type=='stage'){this.stageIndex = index}
        if(type=='task'){this.taskIndex = index}
        var _this = this
        _this.send({
          headers:'A/ActionDetailModelEdit',
          data:{
            CaseActionDetailContent:_this.model.stage,
            CaseActionDetailId:_this.$route.query.id,
          }
        })
      },
      getUserList:function () {
        var _this = this
        _this.send({
          headers:'E/LawList',
          success:function (res) {
            console.log(res)
          }
        })
      }
    },
    computed:{
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    }
  }
</script>

<style scoped>

</style>